import {styled} from "@mui/material/styles";

export const PageContentArea = styled('div')(({theme}) => ({
    display: 'flex',
    flexDirection: 'column',
    position: "absolute",
    padding: 0,
    margin: 20,
    left: '70px',
    top: '60px',
    width: `calc(100vw - 240px)`,
    height: `calc(100vh - 110px)`,
}))

